import { GameNames } from '../store/slices/GameTypes';
import { setClickableMap, setUI, TClickableItemsINT, TimageINT, TuiINT } from '../store/slices/gameObjectSlice';
import { store } from './../store/store';
import { Action } from './Actions/Action';
import { ImageSourcePropType } from 'react-native';


export interface UIINT {
    image: TimageINT;
    key: string,
    tooltip?: string,
    hide?: boolean,
    show?: boolean,
}
export interface UIClickableItem {
    image: TimageINT;
    highlightImage: TimageINT,
    key: string,
}

type NormalUiType = "insta" | "continue";
type V2firstBeforeCallingJoe = "insta" | "callJoey";
type v2EventingRoutine = "insta" | "inviteAnn" | "GoBar";
type V3RoomAfterRecapBTNS = "insta" | "vanessa" | "ann" | "joey";

export interface globalUIINT {
    v1FirstInstaOpen: NormalUiType,
    V2firstBeforeCallingJoe: V2firstBeforeCallingJoe,
    v2EventingRoutine: v2EventingRoutine,
    v2AtRoom1: NormalUiType,
    v3AfterTOD: NormalUiType,
    V3RoomAfterRecapBTNS: V3RoomAfterRecapBTNS,
    v3End: NormalUiType,
    v4BarButtons: NormalUiType;
    v4HomeButtons: NormalUiType;
    v4EndDayButtons: NormalUiType;
    V5HomeAfterVanessaButtons: NormalUiType;
    v5AfterBeachButtons: NormalUiType;
    v5AfterVanessaOrAnnButtons: NormalUiType;
    v5EndDayButtons: NormalUiType;
    v6FirstButtons: NormalUiType | 'emilyRoom';
    v6RecapButtons: NormalUiType;
    v6EndDayButtons: NormalUiType;
    v7StartButtons: NormalUiType;
    v7EndDayButtons: NormalUiType;
    v7MCroomWait2: NormalUiType;

    V8MCRoomMorning: "insta" | "callAnn";
    V8EndDay1: NormalUiType;
    v8EndDay2: NormalUiType;
    
    V8BeforeNightEvents: NormalUiType;
    
    v9events: NormalUiType;
    v9EndDay2: NormalUiType;

    testPc: "pc2";


}

export default class UI {
    static _globalUI: globalUIINT;
    constructor() { }
    static add(_data: TuiINT) {
        const data = <TuiINT>{ ..._data, displayUI: true, wait: true };
        return new Action(data, GameNames.UI).run(
            function UI(callback: () => void) {
                store.dispatch(setUI(data));
                callback();
            }
            , false);

    }
    static addClickableItem(_data: TClickableItemsINT) {
        const data = <TClickableItemsINT>{ ..._data, displayClickableMap: true, };
        return new Action(data, GameNames.UI).run(
            function UI(callback: () => void) {
                store.dispatch(setClickableMap(data));
                callback();
            }
            , false);

    }

    private static _initialize = (() => {
        Object.defineProperty(UI, "_globalUI", {
            get: () => {
                return store.getState().gameObject.present.ui.answers;
            },

        });
        // Object.defineProperty(UI, "_globalUI", {
        //     get: () => {
        //         return store.getState().gameObject.present.ui.answers;
        //     },

        // });
    })();
}